import * as v from 'valibot';
import { TimestampSchema } from './common';
// =============================================================================
// Device Pairing Schemas
// =============================================================================
export const DevicePairRequestSchema = v.object({
    identity_id: v.string(),
    device_pubkey_jwk: v.string(), // JSON string of JWK
    label: v.optional(v.string()),
    client_type: v.optional(v.string()),
    client_fingerprint: v.optional(v.string()),
});
export const DeviceFinalizeRequestSchema = v.object({
    request_id: v.string(),
    encrypted_km: v.string(),
});
export const DeviceClaimRequestSchema = v.object({
    request_id: v.pipe(v.string(), v.minLength(1)),
    request_secret: v.pipe(v.string(), v.minLength(1)),
});
export const DevicePairResponseSchema = v.object({
    request_id: v.string(),
    request_secret: v.string(),
    expires_at: TimestampSchema, // ISO 8601 format or number
});
export const DeviceFinalizeResponseSchema = v.object({
    success: v.literal(true),
});
export const DeviceClaimResponseSchema = v.object({
    status: v.picklist(['pending', 'approved', 'rejected', 'expired']),
    // Success fields (approved)
    device_key: v.optional(v.object({
        id: v.string(),
        secret: v.string(),
    })),
    identity_id: v.optional(v.string()),
    encrypted_blob: v.optional(v.string()),
    // Pending fields
    retry_after: v.optional(v.number()),
    // General
    error: v.optional(v.string()),
});
export const DeviceAuthCheckResponseSchema = v.object({
    authenticated: v.boolean(),
    device: v.optional(v.object({
        kid: v.string(),
        username: v.string(),
        scopes: v.array(v.string()),
        clientType: v.string(),
    })),
});
// =============================================================================
// Device Objects
// =============================================================================
export const DeviceRequestItemSchema = v.object({
    id: v.string(),
    device_id: v.string(),
    status: v.string(),
    created_at: TimestampSchema,
    expires_at: TimestampSchema,
    client_fingerprint: v.nullable(v.string()),
    client_type: v.nullable(v.string()),
    label: v.nullable(v.string()),
    device_pubkey_jwk: v.nullable(v.string()),
});
export const DeviceRequestsResponseSchema = v.object({
    requests: v.array(DeviceRequestItemSchema),
});
export const DeviceStreamResponseSchema = v.any(); // Stream response
export const DeviceItemSchema = v.object({
    kid: v.string(),
    created_at: TimestampSchema,
    last_used_at: v.nullable(TimestampSchema),
    client_type: v.nullable(v.string()),
    label: v.nullable(v.string()),
    scopes: v.array(v.string()),
});
export const DeviceListResponseSchema = v.object({
    devices: v.array(DeviceItemSchema),
});
//# sourceMappingURL=device.js.map